import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, DropdownMenuSeparator } from "@/components/ui/dropdown-menu";
import { LogOut, User, LayoutDashboard, MessageCircle, Sparkles } from "lucide-react";

const LOGO = "https://customer-assets.emergentagent.com/job_optia-telemedicine/artifacts/d09ijb3r_IMG_6632.jpeg";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const link = ({ isActive }) =>
    `px-3 py-2 rounded-lg text-[15px] transition-colors ${isActive ? "text-teal-700 bg-teal-50" : "text-slate-700 hover:text-teal-700"}`;

  return (
    <header className="sticky top-0 z-40 backdrop-blur-md bg-sand/85 border-b border-slate-200/70">
      <div className="container-optia flex items-center justify-between py-3">
        <Link to="/" className="flex items-center gap-2" data-testid="nav-logo">
          <img src={LOGO} alt="Optia Saúde" className="h-11 w-11 rounded-full object-cover" />
          <span className="font-display font-semibold text-navy-900 text-xl leading-none">Optia <span className="text-teal-600">Saúde</span></span>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          <NavLink to="/profissionais" className={link} data-testid="nav-directory">Profissionais</NavLink>
          {user && <NavLink to="/dashboard" className={link} data-testid="nav-dashboard">Painel</NavLink>}
          {user && <NavLink to="/aurora" className={link} data-testid="nav-aurora">Aurora</NavLink>}
          {user && <NavLink to="/mensagens" className={link} data-testid="nav-messages">Mensagens</NavLink>}
          {user?.role === "patient" && <NavLink to="/prontuario" className={link} data-testid="nav-chart">Prontuário</NavLink>}
          {user?.role === "patient" && <NavLink to="/prescricoes" className={link} data-testid="nav-prescriptions">Prescrições</NavLink>}
          {user?.role === "patient" && <NavLink to="/pre-anamnese" className={link} data-testid="nav-preanamnesis">Pré-consulta</NavLink>}
          {user?.role === "admin" && <NavLink to="/admin" className={link} data-testid="nav-admin">Admin</NavLink>}
        </nav>

        <div className="flex items-center gap-2">
          {!user ? (
            <>
              <Button variant="ghost" onClick={() => navigate("/login")} data-testid="nav-login-btn">Entrar</Button>
              <Button className="bg-teal-500 hover:bg-teal-600 rounded-full px-5" onClick={() => navigate("/cadastro")} data-testid="nav-register-btn">Cadastre-se</Button>
            </>
          ) : (
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <button className="flex items-center gap-2 pl-1 pr-3 py-1 rounded-full bg-white border border-slate-200 hover:border-teal-400 transition" data-testid="nav-user-menu">
                  <div className="h-8 w-8 rounded-full bg-teal-100 grid place-items-center text-teal-700 font-semibold">{user.name?.charAt(0)}</div>
                  <span className="text-sm font-medium text-navy-900 hidden sm:inline">{user.name?.split(" ")[0]}</span>
                </button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="w-56">
                <DropdownMenuItem onClick={() => navigate("/dashboard")} data-testid="menu-dashboard"><LayoutDashboard className="w-4 h-4 mr-2" /> Meu painel</DropdownMenuItem>
                <DropdownMenuItem onClick={() => navigate("/aurora")} data-testid="menu-aurora"><Sparkles className="w-4 h-4 mr-2" /> Aurora</DropdownMenuItem>
                <DropdownMenuItem onClick={() => navigate("/mensagens")} data-testid="menu-messages"><MessageCircle className="w-4 h-4 mr-2" /> Mensagens</DropdownMenuItem>
                <DropdownMenuSeparator />
                <DropdownMenuItem onClick={() => { logout(); navigate("/"); }} data-testid="menu-logout"><LogOut className="w-4 h-4 mr-2" /> Sair</DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          )}
        </div>
      </div>
    </header>
  );
}
